export default function CTASection() {
  return (
    <section className="relative w-full h-screen min-h-[500px] max-h-[800px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Energetic%20streetwear%20shopping%20scene%20with%20colorful%20hoodies%20and%20caps%20scattered%20on%20distressed%20concrete%20floor%2C%20bold%20sunset%20orange%20and%20coral%20lighting%2C%20urban%20warehouse%20vibe%20with%20exposed%20brick%20texture%20in%20background%2C%20dynamic%20editorial%20fashion%20photography%20with%20dramatic%20shadows%2C%20high%20energy%20athletic%20aesthetic%2C%20vibrant%20and%20youthful%20composition%2C%20no%20people&width=1600&height=900&seq=cta-bg-v2-2026&orientation=landscape"
        alt="Get the best Superbuy Spreadsheet finds today"
        title="Superbuy Spreadsheet - Start Shopping Now"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 tracking-wide mb-4">
          GET THE BEST FINDS TODAY
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-lg leading-relaxed mb-8">
          Browse curated Superbuy spreadsheets<br />
          Organized by category, updated weekly
        </p>

        {/* Dual CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center -ml-1">
              <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
            </span>
            SUPERBUY SHEET
            <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full border-2 border-background-50/50 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            BUY IT NOW
            <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}